import { useRef, useState } from 'react';
import { toast } from 'sonner';
import { FileUp, Check, X } from 'lucide-react';
import { loggerFromFile, loggerValue, matchHydrant } from '../lib/profImport';

const nf = (v, d = 2) => (v == null || !Number.isFinite(+v) ? '–' : (+v).toFixed(d).replace('.', ','));
const UNIT = { 1: 'bar', 0.001: 'mbar', 0.01: 'kPa', 0.0689476: 'psi', 0.0980665: 'm WS' };

// pressure logger files (one per hydrant, matched by file name) -> measured pressures for the leak search
export function LoggerImport({ t, project, ls, setLs }) {
  const H = (project.fittings || []).filter((f) => f.type === 'hydrant'), fr = useRef(), [pend, setPend] = useState(null);
  const pick = async (files) => {
    const out = [];
    for (const f of files) {
      try { const lg = await loggerFromFile(f); out.push({ lg, hid: matchHydrant(f.name, H)?.id || '' }); } catch (e) { out.push({ err: f.name }); }
    }
    fr.current.value = '';
    setPend(out);
  };
  const take = () => {
    const log = { ...(ls.log || {}) }, hyd = { ...(ls.hyd || {}) };
    pend.filter((p) => p.lg && p.hid).forEach((p) => { log[p.hid] = p.lg; hyd[p.hid] = loggerValue(p.lg, ls.day, ls.hour) ?? ''; });
    setLs({ log, hyd }); setPend(null); toast.success(t.plogOk);
  };
  return (
    <>
      <button className="btn btn-outline btn-sm" data-testid="lg-import" onClick={() => fr.current.click()}><FileUp size={14} /> {t.plogImport}</button>
      <input ref={fr} type="file" multiple hidden accept=".csv,.txt,.xlsx,.xls,.ods" data-testid="lg-file" onChange={(e) => e.target.files.length && pick([...e.target.files])} />
      {pend && (
        <div className="plog-pend" data-testid="lg-pending">
          <small className="muted">{t.plogHint}</small>
          {pend.map((p, i) => (p.err ? <small key={i} className="aq-err" data-testid={`lg-err-${i}`}>{p.err}: {t.plogErr}</small> : (
            <div key={i} className="plog-row" data-testid={`lg-row-${i}`}>
              <span><b>{p.lg.file}</b><br /><small>{p.lg.n} {t.dprofRows} · {new Date(p.lg.from).toLocaleDateString(t.locale)}–{new Date(p.lg.to).toLocaleDateString(t.locale)} · {UNIT[p.lg.unit] || 'bar'} · {nf(loggerValue(p.lg, ls.day, ls.hour))} bar</small></span>
              <select data-testid={`lg-hyd-${i}`} value={p.hid} onChange={(e) => setPend(pend.map((x, j) => (j === i ? { ...x, hid: e.target.value } : x)))}>
                <option value="">{t.plogPick}</option>{H.map((h) => <option key={h.id} value={h.id}>{h.name || h.id}</option>)}
              </select>
            </div>)))}
          <div className="row">
            <button className="btn btn-accent btn-sm" data-testid="lg-take" disabled={!pend.some((p) => p.lg && p.hid)} onClick={take}><Check size={14} /> {t.plogTake}</button>
            <button className="btn btn-outline btn-sm" data-testid="lg-cancel" onClick={() => setPend(null)}><X size={14} /> {t.btnCancel}</button>
          </div>
        </div>
      )}
    </>
  );
}
